import { Icon } from './Icon.tsx';
import type { IconName } from './Icon.tsx';

/**
 * 아직 만들지 않은 화면.
 *
 * 빈 화면을 내보내는 대신 무엇이 올 자리이고 어느 명세를 보면 되는지 적습니다.
 * 리뷰할 때 "빠뜨린 것"과 "아직 안 만든 것"을 구분할 수 있어야 합니다.
 */
interface Props {
  icon: IconName;
  title: string;
  note: string;
  /** design/screens.md 의 화면 ID */
  screens: string;
}

export function Stub({ icon, title, note, screens }: Props) {
  return (
    <div className="stub">
      <span className="stub__icon">
        <Icon name={icon} size={40} />
      </span>
      <p className="stub__title">{title}</p>
      <p className="stub__note">{note}</p>
      <span className="stub__ref">design/screens.md · {screens}</span>
    </div>
  );
}
